(function () {
  function initRelated(root) {
    if (!root || root.dataset.repolishedRelatedReady === 'true') return;
    root.dataset.repolishedRelatedReady = 'true';

    var container = root.querySelector('[data-product-recommendations]');
    if (!container) return;

    var enabled = container.getAttribute('data-enabled') !== 'false';
    var useCustom = container.getAttribute('data-custom-collection') === 'true';
    if (!enabled || useCustom) return;

    var productId = container.getAttribute('data-product-id');
    var sectionId = container.getAttribute('data-section-id');
    var limit = container.getAttribute('data-limit') || '3';
    var baseUrl = container.getAttribute('data-base-url');
    if (!productId || !sectionId || !baseUrl) return;

    var url =
      baseUrl +
      '?section_id=' +
      encodeURIComponent(sectionId) +
      '&limit=' +
      encodeURIComponent(limit) +
      '&product_id=' +
      encodeURIComponent(productId) +
      '&intent=related';

    root.classList.add('is-loading');

    fetch(url)
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.querySelector('[data-product-recommendations]');
        if (next) {
          container.innerHTML = next.innerHTML;
        }
      })
      .catch(function () {
        /* keep fallback markup if present */
      })
      .finally(function () {
        root.classList.remove('is-loading');
      });
  }

  function initAll() {
    document
      .querySelectorAll('[data-repolished-related-products]')
      .forEach(initRelated);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-repolished-related-products]');
    if (root) {
      root.dataset.repolishedRelatedReady = 'false';
      initRelated(root);
    }
  });
})();
